import {createSlice} from '@reduxjs/toolkit';

export const carPropsSlice = createSlice({
    name: 'carPropsReducer',
    initialState: {
        info: {
            mileage: 0,
            vin: '',
            plate: '',
            mileageType: ''
        },
    },
    reducers: {
        setCarProp: (state, action) => {
            console.log(`DISPATCH`);
            state.info = {...state.info, ...action.payload};
        }
    }
});

export const {
    setCarProp
} = carPropsSlice.actions;

export default carPropsSlice.reducer;